import { useMutation } from "urql";

import { CreateLimitRequestPaymasterDocument } from "../../../../graphql/generated.ts";

export function useCreateLimitRequestPaymaster() {
  return useMutation(CreateLimitRequestPaymasterDocument);
}
